export enum DeveloperApiLogStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

export enum DeveloperApiLogMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}
